import { useEffect, useState } from "react";

export default function PageLoader() {
  const [show, setShow] = useState(false);

  useEffect(() => {
    const t = setTimeout(() => setShow(true), 120);
    return () => clearTimeout(t);
  }, []);

  return (
    <div className="fixed inset-0 z-[100] bg-paper flex flex-col items-center justify-center gap-5">
      <div className="relative w-16 h-16">
        <div className="absolute inset-0 rounded-full border-2 border-lilac/20" />
        <div className="absolute inset-0 rounded-full border-2 border-t-rose border-r-transparent border-b-transparent border-l-transparent animate-spin" />
        <div className="absolute inset-[28%] rounded-full overflow-hidden shadow-glow">
          <img
            src="https://public.readdy.ai/ai/img_res/1f14d549-f67b-46d6-918c-9268972fc256.png"
            alt=""
            className="w-full h-full object-cover"
          />
        </div>
      </div>
      <p
        className={`text-sm text-ink-2 tracking-widest transition-opacity duration-300 ${show ? "opacity-100" : "opacity-0"}`}
      >
        載入中
        <span className="inline-block animate-pulse">.</span>
        <span className="inline-block animate-pulse" style={{ animationDelay: "200ms" }}>.</span>
        <span className="inline-block animate-pulse" style={{ animationDelay: "400ms" }}>.</span>
      </p>
    </div>
  );
}